// extracted by mini-css-extract-plugin
export default {"landingContent":"Landing_landingContent__7d7-H","landingCard":"Landing_landingCard__Slgkq","card":"Landing_card__h86FY"};